import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ConfirmationModal } from '../../../../../../../components/ConfirmationModal';

interface IProps {
  showAnnotationTypeDeleteConfirmationModal: boolean;
  onAnnotationTypeDeleteConfirm: () => Promise<void>;
  onAnnotationTypeDeleteCancel: () => void;
}

export const DeleteAnnotationTypeConfirmationModal = observer((props: IProps): ReactElement => {
  const onCancel = (): void => {
    props.onAnnotationTypeDeleteCancel();
  };

  return (
    <ConfirmationModal
      confirmationHeader={'delete_annotation_type_confirmation'}
      confirmationQuestion={'delete_annotation_type_confirmation_body'}
      onCancel={onCancel}
      onConfirm={props.onAnnotationTypeDeleteConfirm}
      showModal={props.showAnnotationTypeDeleteConfirmationModal}
      confirmationYes={'delete'}
    />
  );
});
